import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import { deleteVocabularyLink } from '../actions';

const VocabularyLinkDeleteTableCell = ({ linkUUID, entity = 'link', deleteRow }) => (
  <Table.Cell collapsing textAlign="center">
    <RowDeleteButton entity={`vocabulary.${entity}`} onClick={() => deleteRow(linkUUID)} />
  </Table.Cell>
);

const mapDispatchToProps = {
  deleteRow: deleteVocabularyLink,
};

export default connect(null, mapDispatchToProps)(VocabularyLinkDeleteTableCell);
